import { RegisterStepsList } from '../../../components/pages/authentication/RegisterSteps/RegisterSteps.types';

export const getStepIdFromPUBStep = (step: RegisterStepsList) => {
  switch (step) {
    case RegisterStepsList.SignUp:
      return 1;
    case RegisterStepsList.Entity:
      return 2;
    case RegisterStepsList.User:
      return 3;
    case RegisterStepsList.Documents:
      return 4;
    case RegisterStepsList.Terminated:
      return 5;
    default:
      return 0;
  }
};

export const getPUBStepFromStepId = (stepId: number) => {
  switch (stepId) {
    case 1:
      return RegisterStepsList.SignUp;
    case 2:
      return RegisterStepsList.Entity;
    case 3:
      return RegisterStepsList.User;
    case 4:
      return RegisterStepsList.Documents;
    case 5:
      return RegisterStepsList.Pending;
    case 6:
      return RegisterStepsList.Terminated;
    default:
      return RegisterStepsList.SignUp;
  }
};

export const getStepIdFromENTStep = (step: RegisterStepsList) => {
  switch (step) {
    case RegisterStepsList.SignUp:
      return 1;
    case RegisterStepsList.Company:
      return 2;
    // case RegisterStepsList.Documents:
    //   return 3;
    case RegisterStepsList.Confirmation:
      return 3;
    case RegisterStepsList.Pending:
      return 5;
    case RegisterStepsList.Terminated:
      return 6;
    default:
      return 0;
  }
};

export const getENTStepFromStepId = (stepId: number) => {
  switch (stepId) {
    case 1:
      return RegisterStepsList.SignUp;
    case 2:
      return RegisterStepsList.Company;
    // case 3:
    //   return RegisterStepsList.Documents;
    case 3:
      return RegisterStepsList.Confirmation;
    case 5:
      return RegisterStepsList.Pending;
    case 6:
      return RegisterStepsList.Terminated;
    default:
      return RegisterStepsList.SignUp;
  }
};
